export default class CreateBackupRequest{
  public constructor(
    public customerId?: string,
    public formId?: string,
    public workingPackageId?: string,
  ){}
}
